/**
 * @generated SignedSource<<f980af03bfe28d82db5c89f6348fe7da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnlockNoteInput = {
  clientMutationId?: string | null;
  noteId: string;
};
export type LockNoteUnlockingMutation$variables = {
  input: UnlockNoteInput;
};
export type LockNoteUnlockingMutation$data = {
  readonly unlockNote: {
    readonly note: {
      readonly canUnlockNote: boolean;
      readonly id: string;
      readonly isLocked: boolean;
    } | null;
  } | null;
};
export type LockNoteUnlockingMutation = {
  response: LockNoteUnlockingMutation$data;
  variables: LockNoteUnlockingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnlockNotePayload",
    "kind": "LinkedField",
    "name": "unlockNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Note",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLocked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUnlockNote",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LockNoteUnlockingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LockNoteUnlockingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "78d64b696d123949dfd390255559cbc1",
    "id": null,
    "metadata": {},
    "name": "LockNoteUnlockingMutation",
    "operationKind": "mutation",
    "text": "mutation LockNoteUnlockingMutation(\n  $input: UnlockNoteInput!\n) {\n  unlockNote(input: $input) {\n    note {\n      id\n      isLocked\n      canUnlockNote\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "589e182271d33028c602d9e5c39f2c07";

export default node;
